import React, { useState } from 'react';
import { Image } from 'react-bootstrap';

const FadeInImage = ({ src, alt, onClick, className = '', style = {}, rounded }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <Image
      loading="lazy"
      src={src}
      alt={alt}
      rounded={rounded}
      onClick={onClick}
      onLoad={() => setLoaded(true)}
      className={`img-fade-in ${loaded ? 'loaded' : ''} ${className}`}
      style={style}
    />
  );
};

export default FadeInImage;
